import {
  InvitationDetails,
  OrganizationMemberSchema,
} from '@skop-app/lib-domain/types'
import type {
  SeatAccessState,
  SeatAwareOrganizationMember,
} from '@/types/seatAccess'

type SeatAwareOrganizationMemberSchema = OrganizationMemberSchema & {
  seatAccessState?: SeatAccessState | null
  seatAccessReason?: string | null
  seatGraceStartedAt?: string | null
  seatGraceEndsAt?: string | null
  seatLicenseOrganizationID?: string | null
}

export const memberAdapter = (
  member: SeatAwareOrganizationMemberSchema,
): SeatAwareOrganizationMember => {
  const invitationDetails: InvitationDetails = member.invitationDetails
    ? JSON.parse(member.invitationDetails)
    : null

  const members = member.organization?.members?.items
    ?.filter((m) => m.status === 'DONE')
    ?.map((m) => ({
      label: m.member.name,
      value: m.userID,
      role: m.role,
      organizationID: m.organizationID || '',
    }))

  return {
    id: member.id,
    userID: member.userID,
    organizationID: member.organizationID,
    projectID: member.projectID,
    name:
      member.status === 'PENDING'
        ? invitationDetails?.name || 'Invité'
        : member?.member?.name || '',
    email: member.status === 'DONE' ? member?.member?.email : member.email,
    role: member.role,
    status: member.status,
    type: member.type,
    onSeat: member.onSeat,
    seatAccessState: member.seatAccessState,
    seatAccessReason: member.seatAccessReason,
    seatGraceStartedAt: member.seatGraceStartedAt,
    seatGraceEndsAt: member.seatGraceEndsAt,
    seatLicenseOrganizationID: member.seatLicenseOrganizationID,
    organizationName: member.organizationID
      ? member.organization?.name
      : invitationDetails?.organizationName || '',
    color: member.organization?.color,
    date: member.updatedAt,
    isMaster: member.organization?.isMaster || false,
    members: members || [],
    shopManager: member?.shopManager || false,
  }
}
